import getScrollbarSize from "@mui/utils/getScrollbarSize";

const isAEMPage = () => {
  return (
    document.location.pathname.startsWith("/web/") ||
    document.location.pathname === "/"
  );
};

let state:
  | { locked: false }
  | { locked: true; originalPadding: string; originalOverflow: string } = {
  locked: false,
};

export const useScrollLock = () => {
  const lockBodyScroll = () => {
    if (isAEMPage()) {
      return;
    }

    if (!state.locked) {
      state = {
        locked: true,
        originalPadding: document.body.style.paddingRight,
        originalOverflow: document.body.style.overflow,
      };

      document.body.style.paddingRight = `${getScrollbarSize(document)}px`;
      document.body.style.overflow = "hidden";
    }
  };

  const unlockBodyScroll = () => {
    if (isAEMPage()) {
      return;
    }

    if (state.locked) {
      document.body.style.paddingRight = state.originalPadding;
      document.body.style.overflow = state.originalOverflow;

      state = { locked: false };
    }
  };

  return { lockBodyScroll, unlockBodyScroll };
};
